export { HTTP_STATUS, LONG_API_TIMEOUT_MS, DEFAULT_PAGE_SIZE } from './consts';
export type { ApiResponse } from './types';
export { ENDPOINTS, ENDPOINTS_V2 } from './endpoints';
export { BannerBackgroundSchema, BannerTemplateSchema } from './models/common';
export type { BannerBackground, BannerTemplate } from './models/common';
export type {
  BannerAIChatTargetType,
  BannerBodyDto,
  BannerBodyElementDto,
  BannerDetailResponseDto,
  BannerImageDto,
  BannerListResponseDto,
  BannerStickerDto,
  BannerSummaryDto,
  BannerTextInfoDto,
  CreateBannerAIChatRequest,
  CreateBannerAIChatResponse,
  CreateBannerRequest,
  CreateBannerResponse,
  CreateVariationRequest,
  RenameVariationRequest,
  RenameVariationResponseDto,
  ResizeBannerRequest,
  ResizeBannerResponseDto,
  SaveVariationThumbnailRequest,
  SaveVariationThumbnailResponse,
  UpdateBannerRequest,
  VariationListRatioDto,
  VariationListResponseDto,
} from './models/banner.schema';
export type {
  ComponentDto,
  CreateAIChatRequest,
  CreateDetailRequest,
  DetailBodyDto,
  DetailResponse,
  GetDetailListResponse,
  ModuleDto,
  PatchDetailResponse,
  UpdateComponentV2Request,
  UpdateDetailRequest,
  UpdateDetailV2Request,
  UpdateModuleRequest,
  UpdateModuleV2Request,
} from './models/detail.schema';
export {
  AiStudioGalleryListSchema,
  AiStudioGallerySchema,
  AiStudioImageSchema,
  AiStudioOriginImageSchema,
  AiStudioPresetListSchema,
  AiStudioReferenceImageSchema,
  deriveGalleryStatus,
} from './models/image-generation.schema';
export type {
  AiStudioGallery,
  AiStudioGalleryList,
  AiStudioImage,
  AiStudioPreset,
  CreateAiStudioImageRequest,
  CreateInpaintingRequest,
  DeleteGalleryImageRequest,
  GalleryStatus,
  ImageRatio,
  SaveGalleryImageToAssetRequest,
} from './models/image-generation.schema';
export type {
  CreditCode,
  CreditInfoResponse,
  Plan,
} from './models/credit.schema';
export type { MetaResponse } from './models/meta.schema';
export { ProductSchema, ProductTypeSchema } from './models/product.schema';
export type {
  AddProductAttachmentV2Request,
  AttachmentDto,
  CreateProductResponse,
  CreateProductV2Request,
  DeleteProductAttachmentResponse,
  ListProductResponse,
  PostPresignedUrlRequest,
  ProductDto,
  ProductRequestParams,
  ReadProductResponse,
  SortBy,
  Status,
  UpdateProductImageInfoRequest,
  UpdateProductMainImageRequest,
  UpdateProductRequest,
  UpdateProductResponse,
} from './models/product.schema';
export type { GetUserProfileResponse } from './models/user.schema';
export type {
  CreateVideoRequest,
  CreateVideoResponse,
  GeneratingStatus,
  ListVideosResponse,
  ReadVideoResponse,
  VideoDto,
  VideoRatio,
  VideoResolution,
  VideoSourceDto,
  VideoStatus,
  VideoStyle,
  VideoType,
} from './models/video.schema';
export { isApiError, apiInstance, ApiError } from './instance';
export {
  queryClient,
  createMutationDefaults,
  useMutationStore,
  MUTATION_KEYS,
  QUERY_KEYS,
} from './react-query';
export {
  clearGlobalErrorHandler,
  setGlobalErrorHandler,
} from './react-query/global-error-handler-ref';
export {
  getStatusEntry,
  useApiErrorHandler,
  safeParseSocketResponse,
  isHandledApiError,
  isCreditShortageCode,
  isCreditShortageError,
} from './error';
export { socketInstance } from './websocket/instance';
export { generateUid } from './websocket/lib';
export type {
  AIChatOngoingTaskResponse,
  AIChatResultResponse,
  AiStudioOngoingTaskResponse,
  AiStudioResultResponse,
  BannerAIChatOngoingTaskResponse,
  BannerAIChatResultResponse,
  BannerOngoingTaskResponse,
  BannerResultResponse,
  CreditResultResponse,
  DetailOngoingTaskResponse,
  DetailResultResponse,
  NotificationProductResponse,
  ProductGenerationResultResponse,
  VideoGenerationResponse,
  VideoOngoingTaskResponse,
} from './websocket/socket.schema';
export { SOCKET_EVENT } from './websocket/types';
export type {
  ISocketService,
  MessageData,
  SocketResponse,
} from './websocket/types';
export { useSocket } from './websocket/useSocket';
